import { render } from "./declareDetails.vue?vue&type=template&id=6878294a&scoped=true"
import script from "./declareDetails.vue?vue&type=script&lang=js"
export * from "./declareDetails.vue?vue&type=script&lang=js"

import "./declareDetails.vue?vue&type=style&index=0&id=6878294a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6878294a"]])

export default __exports__